export default $simulatorForm => {
  const getForm = () => $simulatorForm.form
  const getOpenModal = () => $simulatorForm.openModal
  const getSucceeded = () => $simulatorForm.succeeded
  const getLoading = () => $simulatorForm.loading

  return { getForm, getOpenModal, getSucceeded, getLoading }
}
